import React, { useState } from 'react';

import Icon from '../../components/AppIcon';
import Header from '../../components/ui/Header';
import Footer from '../landing-page/components/Footer';

const IletisimPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e?.target?.name]: e?.target?.value }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    // Simulate form submission
    await new Promise(r => setTimeout(r, 1000));
    setLoading(false);
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100">
      <Header />
      {/* Hero */}
      <section className="pt-24 pb-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-900 to-gray-950">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full px-4 py-2 mb-6">
            <Icon name="MessageCircle" size={16} className="text-cyan-400" />
            <span className="text-cyan-400 text-sm font-medium">Bize Ulaşın</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            İletişim
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Sorularınız, önerileriniz veya iş birliği teklifleriniz için bizimle iletişime geçin.
          </p>
        </div>
      </section>
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12">

          {/* Left: Info + Map */}
          <div className="space-y-8">
            {/* Company Info */}
            <div className="bg-gray-900 rounded-2xl p-8 border border-gray-800">
              <h2 className="text-2xl font-bold text-white mb-6">Şirket Bilgileri</h2>
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-cyan-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name="Building2" size={20} className="text-cyan-400" />
                  </div>
                  <div>
                    <p className="text-white font-semibold">Sıfır Noktası</p>
                    <p className="text-gray-400 text-sm">Serhat ÇOKUÇKUN</p>
                    <p className="text-xs text-cyan-500 mt-1">PaddleTurkiye — Tescilli Marka</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-cyan-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name="MapPin" size={20} className="text-cyan-400" />
                  </div>
                  <div>
                    <p className="text-white font-semibold">Adres</p>
                    <p className="text-gray-400 text-sm leading-relaxed">
                      Adalet Mah. Manas Blv. No: 47 B<br />
                      (Folkart Towers) İç Kapı No: 2601<br />
                      Bayraklı / İZMİR
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-cyan-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name="Phone" size={20} className="text-cyan-400" />
                  </div>
                  <div>
                    <p className="text-white font-semibold">Telefon</p>
                    <a href="tel:+905415423535" className="text-gray-400 text-sm hover:text-cyan-400 transition-colors">
                      +90 541 542 35 35
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-cyan-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name="Mail" size={20} className="text-cyan-400" />
                  </div>
                  <div>
                    <p className="text-white font-semibold">E-posta</p>
                    <a href="mailto:info@paddleturkiye.com" className="text-gray-400 text-sm hover:text-cyan-400 transition-colors">
                      info@paddleturkiye.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Google Maps */}
            <div className="bg-gray-900 rounded-2xl overflow-hidden border border-gray-800">
              <div className="p-4 border-b border-gray-800 flex items-center gap-2">
                <Icon name="Map" size={18} className="text-cyan-400" />
                <span className="text-white font-semibold text-sm">Folkart Towers — Bayraklı, İzmir</span>
              </div>
              <iframe
                title="Folkart Towers Konum"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3126.0!2d27.1667!3d38.4667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bbd8e5b3c3c3c3%3A0x0!2sFolkart+Towers%2C+Bayrakl%C4%B1%2C+%C4%B0zmir!5e0!3m2!1str!2str!4v1680000000000!5m2!1str!2str"
                width="100%"
                height="320"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          {/* Right: Contact Form */}
          <div className="bg-gray-900 rounded-2xl p-8 border border-gray-800">
            <h2 className="text-2xl font-bold text-white mb-6">Mesaj Gönderin</h2>

            {submitted ? (
              <div className="flex flex-col items-center justify-center py-16 text-center">
                <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mb-4">
                  <Icon name="CheckCircle" size={32} className="text-green-400" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Mesajınız İletildi!</h3>
                <p className="text-gray-400 text-sm">En kısa sürede size geri dönüş yapacağız.</p>
                <button
                  onClick={() => { setSubmitted(false); setFormData({ name: '', email: '', phone: '', subject: '', message: '' }); }}
                  className="mt-6 px-6 py-2 bg-gradient-to-r from-blue-500 to-cyan-500 text-white rounded-lg text-sm font-medium hover:opacity-90 transition-opacity"
                >
                  Yeni Mesaj Gönder
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">Ad Soyad *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData?.name}
                      onChange={handleChange}
                      required
                      placeholder="Adınız Soyadınız"
                      className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition-colors text-sm"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-300 mb-2">Telefon</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData?.phone}
                      onChange={handleChange}
                      placeholder="+90 5XX XXX XX XX"
                      className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition-colors text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">E-posta *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData?.email}
                    onChange={handleChange}
                    required
                    placeholder="ornek@email.com"
                    className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition-colors text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">Konu *</label>
                  <select
                    name="subject"
                    value={formData?.subject}
                    onChange={handleChange}
                    required
                    className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-cyan-500 transition-colors text-sm"
                  >
                    <option value="">Konu Seçin</option>
                    <option value="genel">Genel Bilgi</option>
                    <option value="siparis">Sipariş / Ürün</option>
                    <option value="etkinlik">Etkinlik</option>
                    <option value="distributor">Distribütörlük</option>
                    <option value="is-birligi">İş Birliği</option>
                    <option value="diger">Diğer</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">Mesajınız *</label>
                  <textarea
                    name="message"
                    value={formData?.message}
                    onChange={handleChange}
                    required
                    rows={5}
                    placeholder="Mesajınızı buraya yazın..."
                    className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-cyan-500 transition-colors text-sm resize-none"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3 bg-gradient-to-r from-blue-500 to-cyan-500 text-white rounded-lg font-semibold hover:opacity-90 transition-opacity disabled:opacity-60 flex items-center justify-center gap-2"
                >
                  {loading ? (
                    <>
                      <Icon name="Loader2" size={18} className="animate-spin" />
                      Gönderiliyor...
                    </>
                  ) : (
                    <>
                      <Icon name="Send" size={18} />
                      Mesaj Gönder
                    </>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default IletisimPage;
